// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","104":"cf720209ea53d36ee1f6","203":"f4d8d3e0b8adfef3d833","243":"307c1cf31df043fbcfea","556":"336db5910bf911af3b98","720":"f9194daff93ea46a1639","852":"cdd1839a42ad1571d402"}[chunkId] + ".bundle.js";
};